<template>
  <b-container fluid class="p-0">
    <main class="m-auto pt-4 pb-4" style="width: 80%;">
      <div class="m-0" style="width: 80%;">
        <img src="../../src/assets/logo.svg" alt="logo" />
      </div>
      <CommonTitle class="mt-3" :titleProps="'ｅ秘書® 資料のご請求 完了'" />
      <!-- コンテンツ領域 -->
      <b-card>
            <p class="font-weight-bold m-0 fs-14-regular" style="font-size: 1.25rem;">資料のご請求ありがとうございました。ご記入内容にて受付をいたしました。</p>
            <p class="mt-3 mb-3 fs-14-regular">折り返し弊社より、自動返信メールにて資料請求受付通知をお送りいたします。</p>
            <p class="mb-3 fs-14-regular">尚、登録されたE-Mailアドレスが間違っていると、受付通知が届かない場合があります。<br>1時間以上経過しても弊社からのメールが受信できない場合は、恐れ入りますが下記までご連絡下さい。</p>
            <p class="mb-0 fs-14-regular">E-Mail: <a class="text-primary" href="mailto:e-hisyo@bell24.co.jp"><u>e-hisyo@bell24.co.jp</u></a></p>
      </b-card>
      <b-row class="p-0 pl-1 pr-1 row-footer">
        <b-col cols="12" class="m-0 p-0">
          <p class="m-0 mb-3 p-0 text-center fs-14-regular">ご不明な点がございましたら、下記窓口へお問い合わせください。</p>
          <div class="w-100 text-center d-flex align-items-center justify-content-center m-auto">
            <img class="mr-2" src="../assets/tel1_tas_02.png" alt="">
            <u class="fs-24-bold">0120-600-024</u>
            <span class="fs-14-regular span-footer">(全日9時〜21時)</span>
          </div>
        </b-col>
        <div class="w-100 mt-3 text-center sp-p-font-size copy-right-text text-center text-info">
          <p>Copyright © Bellsystem24, Inc. All Rights Reserved</p>
        </div>
      </b-row>
    </main>
  </b-container>
</template>

<script>
// NOTE: 共通タイトルUI
import CommonTitle from '../components/common/CommonTitle'

export default {
  components: {
    CommonTitle
  },
  created () {
    if (process.env.NODE_ENV === 'production') {
      // NOTE: Google Analytics（完了）
      this.$gtag.pageview({
        page_path: 'request_documents_completed',
        page_title: '資料請求：完了'
      })
      this.$gtag.event('conversion', {
        send_to: 'AW-370693557/4Ua2CPyn5-YCELWr4bAB'
      })
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'production') {
      // NOTE: Yextの計測タグを動的に追加する
      let scriptEl = document.createElement('script')
      scriptEl.setAttribute('type', 'text/javascript')
      scriptEl.innerHTML = 'window.ytagQ = window.ytagQ || []; function ytag() {window.ytagQ.push(arguments);} ytag("conversion", {"cid": "f4d4eaae-6ad9-445d-b866-a93b7b9894f2"});'
      scriptEl.classList.add('addAdvertisementTag')
      document.body.appendChild(scriptEl)
    }
  }
}
</script>
<style>
.row-footer {
  margin-top: 4rem;
}
.span-footer {
  margin-left: 3rem;
}
.copy-right-text{
  max-width: 100% !important;
}
@media screen and (max-width: 480px) {
  .sp-h1-font-size {
    font-size: 1.5rem !important;
  }
  .sp-small-font-size {
    font-size: 0.4rem !important;
  }
  .sp-img-size {
    width: auto !important;
    height: 30px !important;
  }
}
</style>
